import { render, staticRenderFns } from "./workly-report.vue?vue&type=template&id=767b64d4&scoped=true&"
import script from "./workly-report.vue?vue&type=script&lang=js&"
export * from "./workly-report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767b64d4",
  null
  
)

export default component.exports